import React from 'react'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from "./sparkle.module.css"

const Sparkle = ({ offerbanner }) => {

  const { appearanceData } = useSelector((state) => state.appearances);
  const categoriesData = appearanceData?.categories;
  const category = categoriesData?.find(cat => cat._id === "67c004ff7639fd1f0090124f");


  return (
    <div className={styles.gallery}>
      <div
        className={styles.col}
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${offerbanner?.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 1, // Keep full image visibility
        }}
      >
        <div className={styles.imagetitle}>
          <h2>{offerbanner?.title}</h2>
          <p>{offerbanner?.subtitle}</p>
          <div style={{ marginTop: 20, position: "relative", zIndex: 10 }}>
            <Link to={offerbanner?.buttonLink} state={category} className={styles.btn1} style={{ cursor: "pointer" }}>
              {offerbanner?.buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Sparkle